import { Component, Input } from '@angular/core';

/**
   * Logger Factory
   * @namespace icon: name of icon to show
   * ES:
   * <ute-icon icon="add"></ute-icon>
*/

@Component({
  selector: 'ute-icon',
  templateUrl: 'ute-icon.component.html'
})
export class UteIconComponent  {
  @Input() icon: string;

  constructor() {}
}


// WEBPACK FOOTER //
// ./src/app/components/commons/atoms/ute-icon/ute-icon.component.ts